import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_entity_hdr_RowClass,
  bl_fi_entity_hdr_RowInterface
} from '../../../dbschema/index';

export class EntityHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_hdr: bl_fi_entity_hdr_RowInterface = new bl_fi_entity_hdr_RowClass();
}
